finderApp.service('cacheService', ['$q', function($q) {
    "use strict";

    var storage = localStorage || sessionStorage || {};


    var cacheService = {
        defaultTtl: 1000 * 60 * 60,
        get: function(key, ttl) {
            var result = JSON.parse(storage[key] || '{}');

            ttl = ttl || result.ttl || this.defaultTtl;

            if (Date.now() < result.time + ttl) {
                return result.value
            }
        },
        set: function(key, value, ttl) {
            ttl = ttl || cacheService.defaultTtl;

            try {
                storage[key] = JSON.stringify({
                    time: Date.now(),
                    ttl: ttl,
                    value: value
                });
            } catch(e) {
                //  Saving to cache was not possible, but we ignore it
            }

            return value;

        },
        parseHttpTtl: function(httpResponse) {
            var expires = httpResponse.headers()['expires'],
                ttl;

            if (expires) {
                ttl = Date.parse(expires) - Date.now();
            }
            return ttl;
        },
        generateKey: function(prefix, data) {
            return [prefix, Util.getCountry(), Util.getLang(), Util.getCacheKey(), cacheService.hash(JSON.stringify([data]))].join('-');
        },
        hash: function(s) {
            var hash = 0,
                strlen = s.length,
                i,
                c;
            if ( strlen === 0 ) {
                return hash;
            }
            for ( i = 0; i < strlen; i++ ) {
                c = s.charCodeAt( i );
                hash = ((hash << 5) - hash) + c;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        },
        executeCached: function(keyPrefix, keyData, worker, ttl) {
            var key = this.generateKey(keyPrefix, keyData),
                cachedResult = cacheService.get(key, ttl);

            if (cachedResult !== undefined) {
                return $q.when(cachedResult);
            } else {
                return worker().then(function(result) {
                    if (typeof ttl === "function") {
                        ttl = ttl(result);
                    }
                    cacheService.set(key, result, ttl);
                    return result;
                });
            }
        }
    };

    return cacheService;
}]);